<div class="container mt-3">
  <div class="card shadow-sm">
    <div class="card-header bg-primary text-white">
      <h4 class="mb-0">{{type}} Request Form</h4>
      <h6 class="mb-0">HR Department</h6>
    </div>
    <div class="card-body">
      <!--<form (ngSubmit)="onSubmit($event)">-->
        <div class="row g-3">
          <!-- Account Type -->
          <div class="col-md-6">
            <label for="accountType" class="form-label">Account Type</label>
            <select id="accountType" #accountType class="form-select form-select-mm" [(ngModel)]="add.accountType" name="accountType" (change)="onAccountTypeChange()">
              <option value="">-- Select --</option>
              <option value="Onboarding">Onboarding</option>
              <option value="Offboarding">Offboarding</option>
              <option value="Role Change">Role Change</option>
            </select>
          </div>

          <!-- Employee ID -->
          <div class="col-md-6">
            <label for="firstName" class="form-label">Employee ID</label>
            <input id="firstName" type="text" #employeeid class="form-control form-control-mm" [(ngModel)]="add.OD_EmployeeID" (keydown.enter)="onemployeeenter(add.OD_EmployeeID)" name="OD_EmployeeID">
          </div>

          <!-- First Name -->
          <div class="col-md-6">
            <label for="firstName" class="form-label">First Name</label>
            <input id="firstName" type="text" #firstName class="form-control form-control-mm" [(ngModel)]="add.firstName" name="firstName" (keydown.enter)="lastName.focus()">
          </div>

          <!-- Last Name -->
          <div class="col-md-6">
            <label for="lastName" class="form-label">Last Name</label>
            <input id="lastName" type="text" #lastName class="form-control form-control-mm" [(ngModel)]="add.lastName" name="lastName" (keydown.enter)="Onlastenter()" >
          </div>
  
          
          <!-- Full Name -->
          <div class="col-md-6">
            <label for="fullName" class="form-label">Full Name</label>
            <input id="fullName" type="text" #fullName class="form-control form-control-mm" [(ngModel)]="add.fullName" (keydown.enter)="Phoneno.focus()" name="fullName" readonly>
          </div>

           <div class="col-md-6">
            <label for="Phoneno" class="form-label">Contact No</label>
            <input id="Phoneno" type="text" #Phoneno class="form-control form-control-mm" [(ngModel)]="add.Phoneno" (keydown.enter)="designation.focus()" name="Phoneno">
          </div>

          <!-- Designation -->
          <div class="col-md-6">
            <label for="designation" class="form-label">Designation</label>
            <select id="designation" class="form-select form-select-mm" #designation [(ngModel)]="add.designation" (keydown.enter)="grade.focus()" name="designation">
              <option value="">-- Select --</option>
              <option *ngFor="let des of Designation" [value]="des.REM_REF_Name">{{des.REM_REF_Name}}</option>
            </select>
          </div>

          <!-- Grade -->
          <div class="col-md-6">
            <label for="grade" class="form-label">Location</label>
            <select id="grade" class="form-select form-select-mm" #grade [(ngModel)]="add.grade" (keydown.enter)="OD_Dateofjoin.focus()" name="grade">
              <option value="">-- Select --</option>
               <option *ngFor="let loc of Location" [value]="loc.REM_REF_Name">{{loc.REM_REF_Name}}</option>
            </select>
          </div>

          <!-- DOJ -->
          <div class="col-md-6">
            <label for="OD_Dateofjoin" class="form-label">Date of Joining</label>
            <input id="OD_Dateofjoin" type="date" #OD_Dateofjoin class="form-control form-control-mm" [(ngModel)]="add.OD_Dateofjoin" name="OD_Dateofjoin">
          </div>

          <!-- Reporter 
          <div class="col-md-6">
            <label for="reporter" class="form-label">Reporter</label>
            <select id="reporter" class="form-select" [(ngModel)]="add.reporter" name="reporter">
              <option value="">-- Select --</option>
              <option value="RS. Gartiten">RS. Gartiten</option>
              <option value="John Doe">John Doe</option>
            </select>
          </div>-->

          <!-- Plant -->
          <div class="col-md-6">
            <label for="plant" class="form-label">Plant</label>
            <select id="plant"class="form-select form-select-mm" #plant [(ngModel)]="add.Plant" (keydown.enter)="Department.focus()" name="Plant">
              <option value="">-- Select --</option>
               <option *ngFor="let pnt of appservice.plant" [value]="pnt.REM_REF_Name">{{ pnt.REM_REF_Name }}</option>
            </select>
          </div>
          

          <!-- Department -->
          <div class="col-md-6">
            <label for="Department" class="form-label">Department</label>
            <select id="Department" class="form-select form-select-mm" #Department [(ngModel)]="add.Department" name="Department">
              <option value="">-- Select --</option>
              <option *ngFor="let emp of departmentdata" [value]="emp.REM_REF_Name">{{ emp.REM_REF_Name}}</option>
            </select>
          </div>
            <div class="col-md-6" *ngIf="add.accountType=='Role Change'">
            <label for="FurtherDepartment" class="form-label">Further Department</label>
            <select id="FurtherDepartment" class="form-select form-select-mm" #FurtherDepartment [(ngModel)]="add.OD_Changing_Department" name="OD_Changing_Department">
              <option value="">-- Select --</option>
              <option *ngFor="let emp of departmentdata" [value]="emp.REM_REF_Name">{{ emp.REM_REF_Name}}</option>
            </select>
          </div>
          <div class="col-md-6">
            <label for="OD_Role" class="form-label">Role</label>
            <select id="OD_Role" class="form-select form-select-mm" #Role [(ngModel)]="add.OD_Role" (keydown.enter)="Reporterid.focus()" name="OD_Role">
              <option value="">-- Select --</option>
              <option value="HR">HR</option>
              <option value="Checker">Checker</option>
              <option value="IT">IT</option>
              
            </select>
          </div>

          <!-- Reporter ID -->
          <div class="col-md-6">
            <label for="Reporterid" class="form-label">Reporting To</label>
            <select id="Reporterid" class="form-select form-select-mm" #Reporterid [(ngModel)]="add.Reporterid" (keydown.enter)="ReporterName.focus()" name="Reporterid" (change)="getstaffdetails(add.Reporterid)">
              <option value="">-- Select --</option>
              <option *ngFor="let emp of Employeeid" [value]="emp.Em_iid">{{ emp.Em_Empcode }}</option>
            </select>
          </div>

          <!-- Reporter Name -->
          <div class="col-md-6">
            <label for="ReporterName" class="form-label">Reporter Name</label>
            <input id="ReporterName" type="text" #ReporterName class="form-control form-control-mm" [(ngModel)]="add.ReporterName" (keydown.enter)="Reporterdesignation.focus()" name="ReporterName">
          </div>

          <!-- Reporter Designation -->
          <div class="col-md-6">
            <label for="Reporterdesignation" class="form-label">Reporter Designation</label>
            <input id="Reporterdesignation" type="text" #Reporterdesignation class="form-control form-control-mm" [(ngModel)]="add.Reporterdesignation" (keydown.enter)="ReporterMailid.focus()" name="Reporterdesignation">
          </div>

          <!-- Reporter Email -->
          <div class="col-md-6">
            <label for="ReporterMailid" class="form-label">Reporter Mail ID</label>
            <input id="ReporterMailid" type="email" #ReporterMailid class="form-control form-control-mm" [(ngModel)]="add.ReporterMailid" (keydown.enter)="requester.focus()" name="ReporterMailid">
          </div>
          

 <!-- <div class="col-md-6" *ngIf="add.accountType=='Role Change'">
            <label for="Reporterid" class="form-label">Further Reporting To</label>
            <select id="Reporterid" class="form-select form-select-mm" #FurtherReporterid [(ngModel)]="add.FurtherReporterid" (keydown.enter)="ReporterName.focus()" name="Reporterid" (change)="GetFurtherstaffDetails(add.FurtherReporterid)">
              <option value="">-- Select --</option>
              <option *ngFor="let emp of Employeeid" [value]="emp.Em_iid">{{ emp.Em_Empcode }}</option>
            </select>
          </div>

           <div class="col-md-6" *ngIf="add.accountType=='Role Change'">
            <label for="ReporterName" class="form-label">Reporter Name</label>
            <input id="ReporterName" type="text" #ReporterName class="form-control form-control-mm" [(ngModel)]="add.FurtherReporterName" (keydown.enter)="Reporterdesignation.focus()" name="ReporterName">
          </div>

          
          <div class="col-md-6" *ngIf="add.accountType=='Role Change'">
            <label for="Reporterdesignation" class="form-label">Reporter Designation</label>
            <input id="Reporterdesignation" type="text" #Reporterdesignation class="form-control form-control-mm" [(ngModel)]="add.FurtherReporterdesignation" (keydown.enter)="ReporterMailid.focus()" name="Reporterdesignation">
          </div> -->




          <!-- Requester Name -->
          <div class="col-md-6">
            <label for="requester" class="form-label">Requester Name</label>
            <input id="requester" type="text" #requester class="form-control form-control-mm" [(ngModel)]="add.requester" (keydown.enter)="btnsubmit.focus()" name="requester" readonly>
          </div>
        </div>

        <div class="d-grid mt-4">
          <button type="submit" #btnsubmit class="btn btn-primary btn-mm px-4"  (click)="onSubmit()">Submit</button>
        </div>
      <!--</form>-->
    </div>
  </div>
</div>
